export default {
  FIELD_VALIDATION_FAILURE: 'field_validation_failure',
};
